itsoftApp.createModule("scrollAnimate", ["scrollEffects"], function() {

    var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffects,
        fadeInElements = document.querySelectorAll(".fadeIn"),
        elementsInvisible = document.querySelectorAll(".js-invisible");

        //анимация fadeIn элементов

    var initAnimation = function () {
    	if (fadeInElements) {
	        for (var i = 0; i < fadeInElements.length; i++) {
	            new ScrollEffects(fadeInElements[i], "fadeIn--show");
	        }
	    }

	    if (elementsInvisible) {
	        for (var j = 0; j < elementsInvisible.length; j++) {
	            new ScrollEffects(elementsInvisible[j], "js-visible", "js-invisible");
	        }
	    }
    }

    itsoftApp.modules.pageLoad.addEvent(initAnimation);
});
